import React, { useEffect, useState } from "react";
import "./member-details.css";
import { useDispatch, useSelector } from "react-redux";
import { getClientMemberDetailsApi } from "../../../../redux/action/Client-Member";
import { useParams } from "react-router-dom";
import { riskStatusBadge, statusBadge } from "../MemberTable/MemberTableConfig";
import useIsMobile from "../shared/Mobile-Responsive";
import { ArrowLeft, X, ExternalLink, Share2, ChevronUp } from 'lucide-react';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const MemberDetails = ({ onBack, onClose, onShare, onExport }) => {
  const [status, setStatus] = React.useState("inactive");
const [activeTab, setActiveTab] = useState('profile');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const { clientId } = useParams();
  const dispatch = useDispatch();
   const isMobile = useIsMobile();
  const {
    clientMemberDetails,
    clientMemberDetailsLoading,
    clientMemberDetailsError,
  } = useSelector((state) => state.CLIENT_MEMBER);

const handleEmailShare = () => {
  handleSaveFile(); // still downloads the XLSX locally

  const subject = encodeURIComponent("Member Details");
  const body = encodeURIComponent(
    "Hi,\n\nPlease find the attached member details file.\n\nThanks!"
  );

  // Opens user's default email app (Gmail, Outlook, etc.)
  window.location.href = `mailto:?subject=${subject}&body=${body}`;
};



  useEffect(() => {
    if (clientId) {
      dispatch(getClientMemberDetailsApi(clientId));
    }
  }, [clientId, dispatch]);

  

  useEffect(() => {
    if (clientMemberDetails?.status) {
      setStatus(clientMemberDetails.status.toLowerCase());
    }
  }, [clientMemberDetails?.status]);

  const sessionHistory = clientMemberDetails?.sessionHistory || [];
  console.log(clientMemberDetails, "clientMemberDetailsclientMemberDetails");

  const getOrdinal = (n) => {
  if (n % 100 >= 11 && n % 100 <= 13) return `${n}th`;
  switch (n % 10) {
    case 1: return `${n}st`;
    case 2: return `${n}nd`;
    case 3: return `${n}rd`;
    default: return `${n}th`;
  }
};
const handleSaveFile = () => {
  if (!clientMemberDetails) return;

  try {
    const exportData = [
      {
        "Member ID": clientMemberDetails.memberId || "",
        Name: clientMemberDetails.name || "",
        "Email Address": clientMemberDetails.emailAddress || "",
        "Contact Number": clientMemberDetails.contactNumber || "",
        Gender: clientMemberDetails.gender || "",
        "Joined On": clientMemberDetails.joinedOn || "",
        "Risk Level": clientMemberDetails.risk || "",
        Departments: clientMemberDetails.departments?.join(", ") || "",
        Locations: clientMemberDetails.locations?.join(", ") || "",
        "Custom Groups": clientMemberDetails.customGroups?.join(", ") || "",
        "Total Appointments": clientMemberDetails.totalAppointments || 0,
        "Prescriptions Issued": clientMemberDetails.prescriptionsIssued || 0,
        "Follow Ups": clientMemberDetails.followUps || 0,
        Status: clientMemberDetails.status || "",
        "Emergency Contact Name": clientMemberDetails.emergencyContactName || "",
        "Emergency Contact Number": clientMemberDetails.emergencyContactNumber || "",
        "Emergency Contact Relationship": clientMemberDetails.emergencyContactRelationship || "",
        "Age/DOB": clientMemberDetails.ageDob || "",
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Member Details");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `Member_${clientMemberDetails.memberId || "Details"}.xlsx`);

    console.log("✅ File saved locally!");
  } catch (error) {
    console.error("❌ Error saving file", error);
  }
};

  return (

    <>
    {isMobile ? (
      <>
      <div className="font-poppins bg-white min-h-screen  mx-auto">
      {/* Header */}
      <div className="bg-white px-2  py-4 flex items-center justify-between border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9]">
        <div className="flex items-center gap-3">
          <button onClick={onBack} className="text-[#171717] bg-transparent border-0 p-0">
            <ArrowLeft size={20} />
          </button>
          <h1 className="text-xl font-bold text-[#171717] font-poppins m-0">Member Details</h1>
        </div>
         <div className="header-actions flex items-center gap-2 relative">
  <button
    title="Export"
    className="flex items-center justify-center w-9 h-9 p-0 bg-white rounded-xl shadow-sm hover:bg-[#F8FAFC] transition-colors border-[1px] border-solid border-[#E2E8F0] cursor-pointer"
    onClick={handleSaveFile}
  >
    <ExternalLink className="h-4 w-4 text-[#2563EB]" />
  </button>

  {/* Share dropdown toggle */}
  <div className="relative">
    <button
      title="Share"
      className="flex items-center justify-center w-9 h-9 p-0 bg-white rounded-xl shadow-sm hover:bg-[#F8FAFC] transition-colors border-[1px] border-solid border-[#E2E8F0] cursor-pointer"
      onClick={() => setIsDropdownOpen(prev => !prev)}
    >
      <Share2 className="h-4 w-4 text-[#2563EB]" />
    </button>

    {isDropdownOpen && (
      <div
        className="absolute right-0 mt-2 w-40 bg-white border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-lg z-[9999] overflow-hidden font-poppins"
      >
        <button
          className="block w-full text-left px-4 py-2 text-sm text-[#334155] bg-white border-0 hover:bg-[#F8FAFC]"
          onClick={handleEmailShare}
        >
          Share on Email
        </button>
        <button
          className="block w-full text-left px-4 py-2 text-sm text-[#334155] bg-white border-0 hover:bg-[#F8FAFC]"
          onClick={handleSaveFile}
        >
          Save as File
        </button>
      </div>
    )}
  </div>

  <button className="p-0 ml-1 hover:bg-gray-100 rounded-full bg-transparent border-0 transition-colors" onClick={onClose}>
    <X className="h-5 w-5 text-[#171717]" />
  </button>
</div>
      </div>

      {/* Tabs */}
      <div className="bg-white px-3 border-b-[1px] border-solid border-x-0 border-t-0 border-[#E2E8F0]">
        <div className="flex">
          <button
            className={`py-3 mr-8 text-sm font-semibold bg-transparent border-0 border-b-2 border-solid transition-colors ${
              activeTab === 'profile'
                ? 'text-[#2563EB] border-[#2563EB]'
                : 'text-[#64748B] border-transparent'
            }`}
            onClick={() => setActiveTab('profile')}
          >
            Profile
          </button>
          <button 
            className={`py-3 mr-8 text-sm font-semibold bg-transparent border-0 border-b-2 border-solid transition-colors ${
              activeTab === 'session'
                ? 'text-[#2563EB] border-[#2563EB]'
                : 'text-[#64748B] border-transparent'
            }`}
            onClick={() => setActiveTab('session')}
          >
            Session History
          </button>
        </div>
      </div>

      {/* Content */}
      <div >
        {activeTab === 'profile' && (
          <div>
            {/* Basic Information */}
            <div className="bg-white px-3 overflow-hidden">
              <div className=" pt-3  flex justify-between items-center">
                <h3 className="text-base font-semibold text-[#171717] m-0">Basic Information</h3>
                <div className="flex items-center gap-3">
                  <span className="text-sm text-[#64748B]">Status</span>
                   <div className="switch-container cursor-default">
                    {/* <span
                      className={`switch-text left ${status === "inactive" ? "active" : ""}`}
                    >
                      Block
                    </span> */}
                    <div className="switch-track cursor-none">
                      <div
                        className={`switch-thumb cursor-none ${status === "active" ? "active cursor-none" : "cursor-none"}`}
                      ></div>
                    </div>
                    <span
                      className={`switch-text right ${status === "active" ? "active" : ""}`}
                    >
                      Active
                    </span>
                  </div>
                
                </div>
              </div>

              <div >
                <div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Name</span>
                    <span className="text-[#171717] text-sm font-medium text-right max-w-[60%] break-words">
                      {clientMemberDetails?.name || "NA"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Gender</span>
                    <span className="text-[#171717] text-sm font-medium">
                      {clientMemberDetails?.gender
                        ? clientMemberDetails.gender.charAt(0).toUpperCase() + clientMemberDetails.gender.slice(1).toLowerCase()
                        : "NA"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Age / DOB</span>
                    <span className="text-[#171717] text-sm font-medium">
                      {clientMemberDetails?.ageDob || "NA"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Contact Number</span>
                    <span className="text-[#171717] text-sm font-medium">
                      {clientMemberDetails?.contactNumber || "NA"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Email Address</span>
                    <span className="text-[#171717] text-sm font-medium text-right max-w-[60%] break-words">
                      {clientMemberDetails?.emailAddress || "NA"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Joined On</span>
                    <span className="text-[#171717] text-sm font-medium">
                      {clientMemberDetails?.joinedOn || "NA"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Emergency Contact Details */}
            <div className="bg-white  overflow-hidden">
              <h3 className="text-sm font-semibold text-[#2563EB] m-0 px-3 pt-2">Emergency Contact Details</h3>
              <div className="px-3 ">
                <div className="space-y-1">
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Contact Name</span>
                    <span className="text-[#171717] text-sm font-medium">
                      {clientMemberDetails?.emergencyContactName || "NA"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Relationship</span>
                    <span className="text-[#171717] text-sm font-medium">
                      {clientMemberDetails?.emergencyContactRelationship || "NA"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Contact Number</span>
                    <span className="text-[#171717] text-sm font-medium">
                      {clientMemberDetails?.emergencyContactNumber || "NA"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Organizational Information */}
            <div className="bg-white overflow-hidden">
              <div className="px-3 pt-2 flex justify-between items-center">
                <h3 className="text-base font-semibold text-[#171717] m-0">Organizational Information</h3>
                <div className="text-[#64748B] rotate-180">
                  <ChevronUp size={18} />
                </div>
              </div>
              <div className="px-3 ">
                <div className="space-y-1">
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Institution/Organization</span>
                    <span className="text-[#171717] text-sm font-medium text-right max-w-[60%] break-words">
                      {localStorage.getItem("orgName") || "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between items-start py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Custom Groups</span>
                    <span className="text-[#171717] text-sm font-medium text-right max-w-[60%] break-words">
                      {clientMemberDetails?.customGroups?.length
                        ? clientMemberDetails.customGroups.join(", ")
                        : "NA"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="bg-white   overflow-hidden">
              <h3 className="text-base font-semibold text-[#171717] m-0 px-3 pt-2">Stats</h3>
              <div className="px-3">
                <div className="space-y-1">
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Risk</span>
                    {riskStatusBadge(clientMemberDetails?.risk)}
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Total Appointments</span>
                    <span className="text-[#171717] font-semibold text-base">
                      {clientMemberDetails?.totalAppointments || 0}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Completed</span>
                    <span className="text-[#171717] font-semibold text-base">
                      {clientMemberDetails?.completed || 0}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Follow-ups</span>
                    <span className="text-[#171717] font-semibold text-base">
                      {clientMemberDetails?.followUps || 0}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
                    <span className="text-[#64748B] text-sm">Prescriptions Issued</span>
                    <span className="text-[#171717] font-semibold text-base">
                      {clientMemberDetails?.prescriptionsIssued || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'session' && (
          <div>
            <div className="mt-6 px-3">
              <h3 className="text-base font-semibold text-[#171717] mb-2">History</h3>
              <p className="text-[#64748B] text-xs italic mb-6 leading-relaxed">
                Some sessions for this member may have been booked anonymously and are not shown here for privacy reasons.
              </p>
              
              <div className="space-y-8">
                {sessionHistory?.map((session, index) => (
                  <div key={index} className="flex">
                    <div className="flex flex-col items-center mr-4 w-5">
                      <div className="w-4 h-4 bg-[#2563EB] rounded-full mb-2 flex-shrink-0"></div>
                      {index < sessionHistory.length - 1 && (
                        <div className="w-0.5 h-16 bg-[#E2E8F0] flex-grow"></div>
                      )}
                    </div>
                    <div className="flex-1">
                      <div className="text-[#64748B] text-sm mb-2">
                        {session.appointmentDate || "NA"}
                      </div>
                      <div className="bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm p-4">
                        <div className="flex justify-between items-start">
                          <div className="flex-1">
                            <h4 className="text-base font-semibold text-[#171717] mb-1 m-0">
                              {getOrdinal(index + 1)} Consultation                          </h4>
                            <p className="text-[#64748B] text-sm m-0">
                              {session.counsellorName || "NA"}
                            </p>
                          </div>
                          
                          <div className="flex flex-col items-end gap-1.5">
                        <div
  className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold text-[#4B61FF]
    ${[session.status] }`}
>
  <div className="w-2 h-2 rounded-full bg-current"></div>
  {session.status?.replace(/_/g, " ") || "NA"}
</div>
                            <div className="text-[#64748B] text-xs text-right">
                              {session.mode || "NA"}
                            </div>
                            {/* {session.risk && riskStatusBadge(session.risk)} */}
                                                      <p className="session-type pt-2">{riskStatusBadge(clientMemberDetails?.risk)}</p>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
      </>
    ):(
      <>
       <div className="member-details-container">
      <div className="member-details-wrapper">
        {/* Header */}
        <div className="header">
          <div className="header-left">
            <button className="p-0 hover:bg-gray-100 rounded-full bg-transparent border-0" onClick={onBack}>
              <ArrowLeft className="h-5 w-5 text-[#171717]" />
            </button>
            <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">Member Details</h1>
          </div>
         <div className="header-actions flex items-center gap-2 relative">
  <button
    title="Export"
    className="flex items-center justify-center w-9 h-9 p-0 bg-white rounded-xl shadow-sm hover:bg-[#F8FAFC] transition-colors border-[1px] border-solid border-[#E2E8F0] cursor-pointer"
    onClick={handleSaveFile}
  >
    <ExternalLink className="h-4 w-4 text-[#2563EB]" />
  </button>

  {/* Share dropdown toggle */}
  <div className="relative">
    <button
      title="Share"
      className="flex items-center justify-center w-9 h-9 p-0 bg-white rounded-xl shadow-sm hover:bg-[#F8FAFC] transition-colors border-[1px] border-solid border-[#E2E8F0] cursor-pointer"
      onClick={() => setIsDropdownOpen(prev => !prev)}
    >
      <Share2 className="h-4 w-4 text-[#2563EB]" />
    </button>

    {isDropdownOpen && (
      <div
        className="absolute right-0 mt-2 w-40 bg-white border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-lg z-[9999] overflow-hidden font-poppins"
      >
        <button
          className="block w-full text-left px-4 py-2 text-sm text-[#334155] bg-white border-0 hover:bg-[#F8FAFC]"
          onClick={handleEmailShare}
        >
          Share on Email
        </button>
        <button
          className="block w-full text-left px-4 py-2 text-sm text-[#334155] bg-white border-0 hover:bg-[#F8FAFC]"
          onClick={handleSaveFile}
        >
          Save as File
        </button>
      </div>
    )}
  </div>

  <button className="p-0 ml-1 hover:bg-gray-100 rounded-full bg-transparent border-0 transition-colors" onClick={onClose}>
    <X className="h-5 w-5 text-[#171717]" />
  </button>
</div>

        </div>

        <div className="main-content">
          {/* Left Column */}
          <div className="left-section">
            {/* Basic Information Section */}
            <div className="section">
              <div className="section-header">
                <h3 className="section-title">Basic Information</h3>
                {/* Status Toggle */}
                <div className="status-toggle">
                  <span className="status-label">Status</span>
                  {/* <div className="switch-container">
                    <span
                      className={`switch-text left ${status === "inactive" ? "active" : ""
                        }`}
                    >
                      Block
                    </span>
                    <div
                      className="switch-track"
                      onClick={() =>
                        setStatus((prev) =>
                          prev === "active" ? "inactive" : "active"
                        )
                      }
                    >
                      <div
                        className={`switch-thumb ${status === "active" ? "active" : ""
                          }`}
                      ></div>
                    </div>
                    <span
                      className={`switch-text right ${status === "active" ? "active" : ""
                        }`}
                    >
                      Active
                    </span>
                  </div> */}
                  <div className="switch-container cursor-default">
                    {/* <span
                      className={`switch-text left ${status === "inactive" ? "active" : ""}`}
                    >
                      Block
                    </span> */}
                    <div className="switch-track cursor-none">
                      <div
                        className={`switch-thumb cursor-none ${status === "active" ? "active cursor-none" : "cursor-none"}`}
                      ></div>
                    </div>
                    <span
                      className={`switch-text right ${status === "active" ? "active" : ""}`}
                    >
                      Active
                    </span>
                  </div>

                </div>
              </div>

              <div className="info-list">
                <div className="info-item">
                  <span className="label">Member ID</span>
                  <span className="value member-id">
                    {clientMemberDetails?.memberId || "NA"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Name</span>
                  <span className="value">
                    {clientMemberDetails?.name || "NA"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Gender</span>
                  <span className="value">
                    {clientMemberDetails?.gender
                      ? clientMemberDetails.gender.charAt(0).toUpperCase() +
                      clientMemberDetails.gender.slice(1).toLowerCase()
                      : "NA"}
                  </span>
                </div>

                <div className="info-item">
                  <span className="label">Age / DOB</span>
                  {/* <span className="value">27yr | 10-10-1998</span> */}
                  <span className="value">
                    {clientMemberDetails?.ageDob || "NA"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Contact Number</span>
                  <span className="value">
                    {clientMemberDetails?.contactNumber || "NA"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Email Address</span>
                  <span className="value">
                    {clientMemberDetails?.emailAddress || "NA"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Joined On</span>
                  <span className="value">
                    {clientMemberDetails?.joinedOn || "NA"}
                  </span>
                </div>
              </div>
            </div>

            {/* Emergency Contact Details */}
            <div className="section">
              <h3 className="section-title">Emergency Contact Details</h3>
              <div className="info-list" style={{ marginTop: "16px" }}>
                <div className="info-item">
                  <span className="label">Name</span>
                  <span className="value ">
                    {clientMemberDetails?.emergencyContactName || "NA"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Relationship</span>
                  <span className="value">
                    {clientMemberDetails?.emergencyContactRelationship || "NA"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Contact Number</span>
                  <span className="value">
                    {clientMemberDetails?.emergencyContactNumber || "NA"}
                  </span>
                </div>
              </div>
            </div>


            {/* Organizational Information */}
            <div className="section">
              <h3 className="section-title">Organizational Information</h3>
              <div className="info-list" style={{ marginTop: "16px" }}>
                <div className="info-item">
                  <span className="label">Institution/Organization</span>
                  <span className="value">
                    {localStorage.getItem("orgName") || "N/A"}
                  </span>
                </div>

                <div className="info-item">
                  <span className="label">Custom Groups</span>
                  <span className="value">
                    {clientMemberDetails?.customGroups?.length
                      ? clientMemberDetails.customGroups.join(", ")
                      : "NA"}
                  </span>
                </div>

                <div className="info-item">
                  <span className="label">Departments</span>
                  <span className="value">
                    {clientMemberDetails?.departments?.length
                      ? clientMemberDetails.departments.join(", ")
                      : "NA"}
                  </span>
                </div>

                <div className="info-item">
                  <span className="label">Locations</span>
                  <span className="value">
                    {clientMemberDetails?.locations?.length
                      ? clientMemberDetails.locations.join(", ")
                      : "NA"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="right-section">
            {/* Overview Stats */}
            <div className="section">
              <h3 className="section-title">Overview Stats</h3>
              <div
                className="info-list"
                style={{ marginTop: "16px" }}

              >
                <div className="stat-item">
                  <span className="stat-label">Risk</span>
                  <span >
                    {riskStatusBadge(clientMemberDetails?.risk)}
                  </span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Total Appointments</span>
                  <span className="stat-value">
                    {clientMemberDetails?.totalAppointments || 0}
                  </span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Completed</span>
                  <span className="stat-value">
                    {clientMemberDetails?.completed || 0}
                  </span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Follow-ups</span>
                  <span className="stat-value">
                    {clientMemberDetails?.followUps || 0}
                  </span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Prescriptions Issued</span>
                  <span className="stat-value">
                    {clientMemberDetails?.prescriptionsIssued || 0}
                  </span>
                </div>
              </div>
            </div>

            {/* Session History */}
            <div
              className="section"
              style={{
                border: "1px solid #E2E8F0",
                borderRadius: "16px",
                padding: "16px",
                marginTop: "24px",
              }}
            >
              <h3 className="section-title">Session History</h3>
              <p className="history-note">
                Some sessions for this member may have been booked anonymously
                and are not shown here for privacy reasons.
              </p>

              <div className="timeline max-h-[400px] overflow-y-auto pr-2">
                {sessionHistory.map((session, index) => (
                  <div key={index} className="timeline-item">
                    <div className="timeline-left">
                      <div className="timeline-dot"></div>
                      {index < sessionHistory.length - 1 && (
                        <div className="timeline-connector">
                          <div className="timeline-circle"></div>
                        </div>
                      )}
                    </div>
                    <div className="timeline-content">
                      <div className="timeline-date">
                        {session.appointmentDate || "NA"}
                      </div>
                      <div className="session-card">
                        <div className="session-header">
                          <h4 className="session-title">
                              {getOrdinal(index + 1)} Consultation 
                          </h4>
                          <div
                            className={`status-badge ${session.status?.toLowerCase() || "unknown"
                              }`}
                          >
                            <div className="status-indicator"></div>
                          {session.status?.replace(/_/g, " ") || "NA"}
                          </div>
                        </div>
                        <div className="session-footer">
                          <p className="session-doctor">
                            {session.counsellorName || "NA"}
                          </p>
                          <p className="session-type">{session.mode || "NA"}</p>
                        </div>
                        <div className="session-footer">
                          <p className="session-type"></p>
                          <p className="session-type pt-2">{riskStatusBadge(clientMemberDetails?.risk)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </>
    )}

   
    </>
  );
};

export default MemberDetails;
